import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const PrivateRoute = ({ children }) => {
  const { user, setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  useEffect(() => {
    const verifyAuth = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        // Assuming some verification or fetch to check token validity
        try {
          // e.g., verify token or fetch user details
          const response = await fetch("/api/verifyToken", {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response.ok) {
            setUser({ isAuthenticated: true });
          } else {
            setUser({ isAuthenticated: false });
          }
        } catch (error) {
          console.error("Token verification failed", error);
          setUser({ isAuthenticated: false });
        }
      } else {
        setUser({ isAuthenticated: false });
      }
      setLoading(false);
    };

    verifyAuth();
  }, [setUser]);

  if (loading) {
    return <div>{t("Loading")}</div>;
  }

  return user.isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
